import {
  RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA,
  RESTAURANTS_CLEAR_ENTITIES,
  RESTAURANTS_CLEAR_PAGINATION_INFO,
  RESTAURANTS_EDIT_ENTITY,
  RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES,
  RESTAURANTS_FETCH_ENTITIES,
  RESTAURANTS_FETCH_ENTITY,
  RESTAURANTS_SET_PAGE,
  RESTAURANTS_SET_ROWS_PER_PAGE,
  SELECTED_RESTAURANTS_LIST
} from "../action-types/restaurant-types";
import ColumnInterface from "../../interfaces/column";
import AppConstants from "../../AppConstants";

const columns: ColumnInterface[] = [
  {
    id: 'number',
    label: 'Restaurant #',
    minWidth: 170,
    align: 'left',
  },
  { id: 'name', label: 'Address', align: 'left' },
  { id: 'city', label: 'City', align: 'left' },
  { id: 'state', label: 'State/Province', align: 'left' },
  { id: 'country', label: 'Country', align: 'left' },
  { id: 'status', label: 'Status', align: 'right' },
  { id: 'postal', label: 'postal', align: 'right' },
  { id: 'action', label: 'Actions' },
];
const initialState = {
  entities: [],
  entity: {},
  emailTypes: [],
  phoneTypes: [],
  loading: false,
  loaded: false,
  columns,
  paginationConfig: {
    total: 0,
    page: 1,
    rowsPerPage: AppConstants.rowsPerPage,
  },
  selectedRestaurantsList :[ ]
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESTAURANTS_FETCH_ENTITIES.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        entities: [],
      };
    case RESTAURANTS_EDIT_ENTITY.REQUEST:
    case RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RESTAURANTS_FETCH_ENTITY.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case RESTAURANTS_FETCH_ENTITIES.SUCCESS:
      return {
        ...state,
        entities: action.payload.data.restaurants,
        paginationConfig: {
          ...state.paginationConfig,
          total: action.payload.data.pagination.total,
        },
        entity: {},
        loading: false,
        loaded: true,
      };
    case RESTAURANTS_FETCH_ENTITY.SUCCESS:
      return {
        ...state,
        entity: {
          ...action.payload.data.details,
          phones: action.payload.data.phone,
          emails: action.payload.data.emails,
          brand: action.payload.data.details?.brand,
        },
        loading: false,
        loaded: true,
      };
    case RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.SUCCESS:
      return {
        ...state,
        phoneTypes: action.payload.phones,
        emailTypes: action.payload.emails,
        loading: false,
        loaded: true,
      };
    case RESTAURANTS_EDIT_ENTITY.REJECTED:
    case RESTAURANTS_FETCH_ENTITY.REJECTED:
    case RESTAURANTS_FETCH_ENTITIES.REJECTED:
    case RESTAURANTS_FETCH_EMAIL_AND_PHONE_TYPES.REJECTED:
    case RESTAURANTS_EDIT_ENTITY.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case RESTAURANTS_CLEAR_ENTITIES:
      return {
        ...state,
        entities: [],
        loading: false,
        loaded: false,
        paginationConfig: {
          page: 1,
          rowsPerPage: AppConstants.rowsPerPage,
          total: 0,
        },
      };
    case RESTAURANTS_SET_ROWS_PER_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          rowsPerPage: action.payload,
        },
      };
    case RESTAURANTS_SET_PAGE:
      return {
        ...state,
        paginationConfig: {
          ...state.paginationConfig,
          page: action.payload,
        },
      };
    case RESTAURANTS_CLEAR_PAGINATION_INFO:
      return {
        ...state,
        paginationConfig: {
          page: 1,
          rowsPerPage: AppConstants.rowsPerPage,
          total: 0,
        },
      };
    case RESTAURANTS_CLEAR_EMAIL_AND_PHONE_TYPES_DATA:
      return {
        ...state,
        emailTypes: [],
        phoneTypes: []
      };
    case SELECTED_RESTAURANTS_LIST:
      return {
        ...state,
        selectedRestaurantsList: action.payload
      }
    default:
      return state;
  }
}
